import {createAsyncThunk} from '@reduxjs/toolkit';
import api from 'services/axios';

export const getPins = createAsyncThunk<any, any>('getPins', async (params, thunkApi) => {
  try {
    const response = await api.get(`pin?vendor_id=${params.vendor_id}`, {
      goBaseUrl: true
    });
    return thunkApi.fulfillWithValue(response.data);
  } catch (e: any) {
    return thunkApi.rejectWithValue(e);
  }
});

export const getPin = createAsyncThunk<any, any>('getPin', async (params, thunkApi) => {
  try {
    const response = await api.get(`pin/${params.pin_id}?vendor_id=${params.vendor_id}`, {
      goBaseUrl: true
    });
    return thunkApi.fulfillWithValue(response.data);
  } catch (e: any) {
    return thunkApi.rejectWithValue(e);
  }
});

export const getPinRegions = createAsyncThunk<any, any>(
  'getPinRegions',
  async (params, thunkApi) => {
    try {
      const response = await api.get(`pin/regions?vendor_id=${params.vendor_id}`, {
        goBaseUrl: true
      });
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const getAvailablePins = createAsyncThunk<any, any>(
  'getAvailablePins',
  async (params, thunkApi) => {
    try {
      const response = await api.get(
        `pin/available-pins?polygon_id=${params.polygon_id}&vendor_id=${params.vendor_id}`,
        {
          goBaseUrl: true
        }
      );
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const getPinBasket = createAsyncThunk<any, any>('getPinBasket', async (params, thunkApi) => {
  try {
    const response = await api.get(`pin/basket?vendor_id=${params.vendor_id}`, {
      goBaseUrl: true
    });
    return thunkApi.fulfillWithValue(response.data);
  } catch (e: any) {
    return thunkApi.rejectWithValue(e);
  }
});

export const addToPinBasket = createAsyncThunk<any, any>(
  'addToPinBasket',
  async (body, thunkApi) => {
    try {
      const response = await api.post(`pin/basket?vendor_id=${body.vendor_id}`, body, {
        goBaseUrl: true
      });
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e?.data);
    }
  }
);

export const removeFromPinBasket = createAsyncThunk<any, any>(
  'removeFromPinBasket',
  async (params, thunkApi) => {
    try {
      const response = await api.delete(
        `pin/basket?vendor_id=${params.vendor_id}&basket_item=${params.basket_item}`,
        {
          goBaseUrl: true
        }
      );
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const paymentCheck = createAsyncThunk<any, any>('paymentCheck', async (body, thunkApi) => {
  try {
    const response = await api.post(`pin/payment?vendor_id=${body.vendor_id}`, null, {
      goBaseUrl: true
    });
    return thunkApi.fulfillWithValue(response.data);
  } catch (e: any) {
    return thunkApi.rejectWithValue(e);
  }
});

export const confirmPayment = createAsyncThunk<any, any>(
  'confirmPayment',
  async (data, thunkApi) => {
    try {
      const response = await api.post(
        `pin/payment/confirm?vendor_id=${data.vendor_id}`,
        {code: data.code},
        {
          goBaseUrl: true
        }
      );
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const addPinBulk = createAsyncThunk<any, any>('addPinBulk', async (data, thunkApi) => {
  try {
    const response = await api.post(
      `pin/basket?vendor_id=${data.vendor_id}`,
      {available_pin_id: data.available_pin_id},
      {
        goBaseUrl: true
      }
    );
    return thunkApi.fulfillWithValue(response.data);
  } catch (e: any) {
    return thunkApi.rejectWithValue(e);
  }
});
